import React from "react";
import { useProjectDownload } from "../../../hooks/useProjectDownload";
import { DownloadDropdown } from "../../../components/DownloadDropdown";
import { DownloadVideoModal } from "../../../components/MenuOptions";
import { DownloadOverlay } from "../../../components/DownloadOverlay";

interface Props {
  projectId: number;
  projectTitle: string;
  /** When provided, skips the API fetch. Pass when files are already loaded. */
  files?: any[];
  /** The project's content_channels; pass with `files` so the zip gets one
   *  folder per channel instance. */
  channels?: any[];
  /** Grays out the button without hiding it. */
  disabled?: boolean;
  /** Renders an icon-only button instead of the full "Download" button. */
  small?: boolean;
  /** Tooltip label shown on the icon button (only used when small=true). */
  tooltipTitle?: string;
  allowedFileTypes?: Set<string> | null;
  /** Zip unapproved videos in the requested format (staff, pre-approval brands). */
  allowUnapproved?: boolean;
}

export function ProjectDownloadBtn({
  projectId,
  projectTitle,
  files,
  channels,
  disabled = false,
  small = false,
  tooltipTitle,
  allowedFileTypes,
  allowUnapproved,
}: Props) {
  const {
    showOptions,
    setShowOptions,
    isDownloading,
    downloadLink,
    setDownloadLink,
    modalOpen,
    setModalOpen,
    handleDownload,
  } = useProjectDownload({ projectId, projectTitle, files, channels, allowedFileTypes, allowUnapproved });

  return (
    <>
      <DownloadOverlay visible={isDownloading} />

      {!isDownloading && (
        <DownloadDropdown
          small={small}
          disabled={disabled}
          tooltipTitle={tooltipTitle}
          isOpen={showOptions}
          isDownloading={false}
          onToggle={() => setShowOptions((v) => !v)}
          onSelect={handleDownload}
          onClickAway={() => setShowOptions(false)}
          allowedFileTypes={allowedFileTypes}
        />
      )}

      <DownloadVideoModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setDownloadLink("");
        }}
        downloadSource={downloadLink}
      />
    </>
  );
}
